export default {
  title: 'Luo uusi salasana',
  description: 'Luo tilillesi uusi salasana.',
  form: {
    new_password: {
      label: 'Uusi salasana',
      placeholder: 'Anna salasana',
      requirements: 'Salasanassa tulee olla 8 merkkiä, iso kirjain ja numero',
    },
    confirm_password: {
      label: 'Vahvista uusi salasana',
      placeholder: 'Vahvista salasana',
    },
    error_messages: {
      missing_info: 'Puuttuvat tiedot',
    },
  },
  buttons: {
    update_password: 'Päivitä salasana',
  },
};
